import { numberThousand } from 'Data/format.js'

export function formatPercentage(value) {
  return `${numberThousand(value * 100)}%`
}
